// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_o3Hha","icon":"index_icon_cBJ6Y","text":"index_text_o73Ce","btn":"index_btn_khT8h"};